import React, { useEffect, useState } from 'react'
import Sidebar from '../sidebar'
import { OffcanvasBody, Offcanvas } from 'reactstrap'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import ProfileMenu from '../profile-menu'
import MenuSVG from '../../assets/svg/menu.svg'
import WhatsappSVG from '../../assets/svg/whatsapp.svg'
import BubbleChat from '../../assets/svg/bubble-chat.svg'

import {
  toggleSidebar,
  updateModalStatus,
} from '../../redux/components/components-slice'
import { useHistory, useLocation } from 'react-router-dom'
import CollapsingIcon from '../collapsing-icon'
import NoSubscriptionModal from '../modal/hr-section/subscription/subscription-notification'
import UpdateUserMobileModal from '../modal/update-user-mobile'
import { store } from '../../redux'
import classNames from 'classnames'
import AddPINModal from '../modal/add-pin'
import Button from '../button'
import SwitchSectionModal from '../modal/switch-section'
import moment from 'moment'
import AppMessages from '../../constants/AppMessages'

const mockMessages = [
  {
    id: '1',
    title: 'Important Notice Stamp Duty On Transactions Above ₦10,000 ',
    body: `Dear Valued Customer,

We hope this message finds you well.

In line with the provisions of the new Nigeria Tax Law effective in 2026, we would like to inform you of an update regarding stamp duty charges on transactions.

Please note that a stamp duty charge of ₦50 will now apply to every outgoing transaction of ₦10,000 and above, as required by law.

However, salary and wages payments are exempted from this charge. This means that stamp duty will not be applied to employee salary payments processed through your payroll on CentelHR.

The CentelHR platform has been updated accordingly to ensure compliance with this regulation, and any applicable stamp duty charges will be automatically applied to eligible transactions.

If you have any questions or need further clarification on how this may affect your transactions, our support team will be happy to assist you.

Thank you for your continued trust in CentelHR.

Warm regards,
The CentelHR Team`,
    timestamp: '13/01/2026',
  },
  {
    id: '2',
    title: 'Updated CentelHR Pricing Now In Effect',
    body: `Dear Valued Customer,

We hope you’re doing well.

We’d like to let you know that the updated CentelHR pricing structure has taken effect this month. This update supports ongoing improvements to the platform, including better reliability, stronger regulatory compliance, and enhanced support for your HR, payroll, and spend management needs.

Below is a summary of the current pricing:

Basic Payroll
• Payroll processing: ₦400 per employee
• Payslips (optional): ₦100 per employee

Advanced Payroll
• Includes all Basic Payroll features plus advanced capabilities: ₦1,000 per employee
• Optional add-ons:
– Pension filing: ₦500 per employee
– Tax filing: ₦500 per employee

Spend Management (Vendor Payments)
• Vendor disbursements and automated payment workflows: ₦100 per transaction

We sincerely appreciate your continued partnership. If you have any questions, need further clarification, or would like us to walk you through how this applies to your account, our team will be happy to assist.

Please feel free to reply to this email or contact our support team at any time.

Warm regards,
CentelHR`,
    timestamp: '8/01/2026',
  },
  {
    id: '3',
    title: 'New Nigeria Tax Law Now Integrated On CentelHR',
    body: `
    Dear Valued Customer,

We hope this message finds you well.

We will like to inform you that, in line with the recently implemented Nigerian tax laws, the new PAYE tax calculation framework has now been fully integrated into CentelHR platform.

As a result of this update, you may notice some changes in PAYE deductions and overall payroll figures when running your payroll. These changes are a direct reflection of the new tax rules and relief structures introduced by the government, and not an error on the system.

Please be assured that CentelHR has been updated to ensure accurate calculation and proper remittance of PAYE tax and pension in compliance with the new regulations.

If you have any questions, need clarification on the changes, or would like us to walk you through how this affects your payroll, our support team is always available to assist you.

Thank you for your continued trust in CentelHR.

Warm regards,
The CentelHR Team
    `,
    timestamp: '8/01/2026',
  },
  {
    id: '4',
    title: 'CentelHR Updated Pricing',
    body: `
    Dear Valued Customer,

I hope this message finds you well.

We’d like to let you know that we’ll be updating our pricing structure at CentelHR, effective 1st January 2026. This adjustment reflects the ongoing improvements we’ve made to our platform to enhance efficiency, ensure compliance, and provide even stronger support for your HR and payroll operations.

Here’s a summary of the updated pricing:

• Basic Payroll
New Price - ₦400 per employee
Notes -Payslip option available at ₦100 per employee

• Advanced Payroll
New Price - ₦1000 per employee
Notes - Optional add-ons: Pension and tax filing at ₦500 each per employee

• Spend Management (Vendor Payment)
New Price -₦100 per transaction


• Why the change?
The Basic Payroll plan has been adjusted from ₦100 to ₦400 per employee to reflect the improvements in reliability and compliance, with payslips now offered as an optional add-on.

The Advanced Payroll plan will now be priced at ₦1,000 per employee, with an additional ₦1,000 for organizations that process both pension and tax filings, transparently divided as ₦500 each for pension and tax.

Spend Management remains a flexible, dedicated module that helps you manage vendor payments efficiently while maintaining full control and scalability for your business.

We value your partnership and remain committed to making CentelHR the most reliable and efficient HR solution for your organization. If you have any questions or would like to review your plan in detail, please don’t hesitate to reply to this email or contact our support team.

Warm regards,
CentelHR
    `,
    timestamp: '07/12/2025',
  },
]

const DashboardLayout = ({ children, title }) => {
  const dispatch = useDispatch()
  const { isSidebarOpen, isModalOpen } = useSelector(
    (state) => state.componentsSlice
  )
  const { section } = useSelector((state) => state.sectionSlice)
  const { user } = useSelector((state) => state.userSlice)
  const [open, setOpen] = useState(false)

  const sidebarWidth = '255px'

  const [currentSection, setCurrentSection] = useState('')
  const location = useLocation()
  const [showNoSubModal, setShowNoSubModal] = useState(false)
  const [showUserMobileModal, setShowUserMobileModal] = useState(false)
  const [showSwitchModule, setShowSwitchModule] = useState(false)
  const [showTransactionPIN, setShowTransactionPIN] = useState(false)

  useEffect(() => {
    dispatch(updateModalStatus(false))
  }, [])

  useEffect(() => {
    if (user) {
      if (user?.transaction_pin_status !== 1) {
        setShowTransactionPIN(true)
      }
      setCurrentSection(user.section)
    }
  }, [user])

  useEffect(() => {
    if (section && user) {
      // console.log(moment().isBefore(moment(user.hr_subscription.end_date)));
      // console.log(user.hr_subscription.end_date);
      if (user.mobile) {
        if (
          section.name === 'core hr' &&
          location?.pathname !== '/settings/plans-billings'
        ) {
          if (
            moment().isAfter(moment(user?.hr_subscription?.end_date)) &&
            user?.hr_subscription.status !== 1
          ) {
            store.dispatch(updateModalStatus(true))
            setShowNoSubModal(true)
          }
        } else {
          setShowNoSubModal(false)
        }
      } else {
        store.dispatch(updateModalStatus(true))
        setShowUserMobileModal(true)
      }
    }
  }, [section, user])

  const history = useHistory()

  const handleSidebarToggle = () => {
    dispatch(toggleSidebar())
  }

  return (
    <div className='relative'>
      <div>
        <Offcanvas
          toggle={() => handleSidebarToggle()}
          isOpen={isSidebarOpen}
          style={{ width: sidebarWidth }}
        >
          <OffcanvasBody className='!p-0'>
            <Sidebar />
          </OffcanvasBody>
        </Offcanvas>
      </div>
      {showUserMobileModal ? (
        <UpdateUserMobileModal
          isOpen={showUserMobileModal}
          closeModal={() => {
            setShowUserMobileModal()
          }}
        />
      ) : null}
      {showNoSubModal ? (
        <NoSubscriptionModal
          isOpen={showNoSubModal}
          setShowNoSubModal={setShowNoSubModal}
          closeModal={() => setShowNoSubModal(false)}
        />
      ) : null}
      {showTransactionPIN ? (
        <AddPINModal
          isOpen={showTransactionPIN}
          closeModal={() => setShowTransactionPIN(false)}
        />
      ) : null}
      {showSwitchModule ? (
        <SwitchSectionModal
          isOpen={showSwitchModule}
          closeModal={() => setShowSwitchModule(false)}
          currentSection={currentSection}
        />
      ) : null}
      <div className='flex flex-row max-h-screen'>
        <div className='hidden lg:flex md:flex !min-w-[255px] h-screen inset-0'>
          <Sidebar />
        </div>
        <div className='w-full flex flex-col bg-secondary-2-light overflow-auto'>
          <div className='!opacity-100'>
            <div className='ml-0 bg-white h-[65px] w-full flex items-center justify-between md:pl:0 md:px-[30px] md:border-l-2 border-secondary-2-light '>
              <div className='flex flex-row items-center pl-4 md:pl-0'>
                <button onClick={() => handleSidebarToggle()}>
                  <img src={MenuSVG} alt='menu' className='flex lg:hidden' />
                </button>
                {location.pathname !== '/dashboard' ? (
                  <button
                    className='hidden md:block'
                    onClick={() => history.goBack()}
                  >
                    <CollapsingIcon
                      defaultPosition='right'
                      isopen={true}
                      dashboard={true}
                    />
                  </button>
                ) : null}
                <span
                  className={classNames('hidden md:block header-4 pl-3', {
                    'text-secondary-2': section.name === 'payroll',
                    'text-hr-primary-1': section.name === 'core hr',
                    'text-spend-primary-1': section.name === 'spend',
                  })}
                >
                  {title}
                </span>
              </div>
              <div className='flex flex-row md:-mr-3 mr-4 items-center justify-center gap-16'>
                <Button
                  text='Switch Hub'
                  type='button'
                  theme='primary'
                  className='flex gap-2 h-[35px] w-fit p-2'
                  rightIcon={'change'}
                  textClass={'!text-[12px] font-medium'}
                  onClick={() => {
                    setShowSwitchModule(true)
                  }}
                />
                <div className='hidden md:flex'>
                  <ProfileMenu />
                </div>
              </div>
            </div>
            {/* Page Component */}
            <div className='w-full h-full p-8'>{children}</div>
          </div>
        </div>
      </div>
      <div
        onClick={() => setOpen(true)}
        className='flex gap-2 absolute  top-[70px] right-6 items-center'
      >
        <img src={BubbleChat} alt='centelHr' />
      </div>
      <div className='flex gap-2 absolute  bottom-4 right-6 items-center'>
        <a
          href='https://web.whatsapp.com/send?phone=2349068542948&text=Hi%20there!'
          target='_blank'
          className='hover:scale-110 duration-300'
        >
          <img src={WhatsappSVG} alt='menu' />
        </a>
        <a
          href='https://web.whatsapp.com/send?phone=2349068542948&text=Hi%20there!'
          target='_blank'
          className='flex gap-[3px] z-auto bg-[#75B73B] items-center p-2 px-3 rounded-[30px] cursor-pointer text-[14px] font-bold hover:text-[15px] duration-300 text-white'
          // onClick={() => {
          //   history.push('/contact-us');
          // }}
        >
          Send us a message
        </a>
      </div>
      <AppMessages
        isOpen={open}
        onClose={() => setOpen(false)}
        messages={mockMessages}
      />
    </div>
  )
}

export default DashboardLayout
